// extracted by mini-css-extract-plugin
export default {"mediaImage":"media-image_mediaImage__mer-J","title":"media-image_title__7A-Yd"};